<script setup lang="ts">
useMeta(() => {
  return {
    title: 'Проекты',
  };
});

// import { projects } from 'src/data/projects';

// const model = ref();

// const router = useRouter();

// const carouselRef = ref();

// const breakpoints = {
//   // 700px and up
//   320: {
//     itemsToShow: 1.2,
//     snapAlign: 'left',
//   },
//   700: {
//     itemsToShow: 3.5,
//     snapAlign: 'center',
//   },
//   // 1024 and up
//   1024: {
//     itemsToShow: 3,
//     snapAlign: 'center',
//   },
// };
</script>

<template lang="pug">
q-page.overflow-hidden(style="background-color: #242833;")
    Suspense
      template(#fallback)
        LoadingSkeleton(bg-color="#242833")
      TreProjects
</template>

<style lang="sass" scoped>
</style>
